

















import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Services ---
import AppService from '@/services/app';
import UserService from '@/services/siteUser';

@Component
export default class ReportPDFViewer extends Vue {

  loader: boolean = true;
  pdfUrl = '';

  // we will receive the manifest id as a param, we need to fetch the print url
  async beforeMount() {
    window.scrollTo(0, 0);

    const siteUserId: string = this.$route.params.id;
    if (siteUserId) {
      try {
        // go fetch the report filename
        await this.getReportUrl(parseInt(siteUserId, 10));
       } catch (error) {
        // could not parse int
        AppService.errorHandler('No report could be found for this user. Please contact Customer Support with this Error Code: OCG-042');
       }
    } else {
      // could not find user id in url
      AppService.errorHandler('No report could be found for this user. Please contact Customer Support with this Error Code: OCG-046');
    }

  }

  async getReportUrl(siteUserId: number) {
    try {
      const response = await UserService.getReportUrlBySiteUser({params: { siteUserId: siteUserId}});

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          // do nothing, we don't care if no data or an error comes back
        } else {
          // check if we got a blank filename
          if (response.data.message && response.data.message.length > 0) {
            this.loader = false;
            this.pdfUrl = 'https://media.onlinecareerguidance.co.za/' + response.data.message;
          } else {
            this.loader = false;
            AppService.errorHandler('No report could be found for this user.');
          }          
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {

      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    }
  }

}
